import {css} from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  size: 'small' | 'medium' | 'large';
};

export const InnerLayout = styled.div<Props>(
  ({size}) => css`
    display: grid;
    gap: 12px;
    align-items: end;
    margin-top: 8px;
    grid-template-columns: ${size === 'small' ? '' : '1fr max-content'};
  `
);
